import { Link } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import { aboutFeatures, milestones } from "@/mocks/aboutData";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      {/* Hero */}
      <section className="relative bg-background-100 overflow-hidden">
        <div className="absolute inset-0">
          <img
            alt=""
            src="https://readdy.ai/api/search-image?query=Abstract%20modern%20geometric%20background%20with%20soft%20gradients%20of%20warm%20neutral%20tones%2C%20subtle%20overlapping%20circles%20and%20lines%2C%20clean%20minimalist%20aesthetic%2C%20professional%20corporate%20atmosphere%2C%20light%20airy%20feel%20with%20gentle%20texture%2C%20no%20text%20or%20logos%2C%20elegant%20and%20sophisticated%20design&width=1600&height=500&seq=about-hero-01&orientation=landscape"
            className="w-full h-full object-cover opacity-40"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50" />
        <div className="relative max-w-[860px] mx-auto px-3 md:px-4 py-16 md:py-24 text-center w-full">
          <h1 className="text-2xl md:text-4xl font-black text-foreground-700 mb-4">
            신뢰할 수 있는
            <br />
            <span className="text-primary-500">스포츠 커뮤니티의 새로운 기준</span>
          </h1>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto leading-relaxed">
            월드컵티비 시즌2는 안전한 스포츠 정보와 검증된 사이트 정보를 제공하는
            대한민국 대표 스포츠 커뮤니티입니다
          </p>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-[1000px] mx-auto px-3 md:px-4 py-10 md:py-14">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-700">주요 기능</h2>
          <p className="text-sm text-foreground-600 mt-2">월드컵티비 시즌2가 제공하는 핵심 서비스입니다</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {aboutFeatures.map((feature, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-300 p-5 hover:border-primary-500/30 transition-colors"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center mb-4">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 text-lg">
                  <i className={feature.icon} />
                </span>
              </div>
              <h3 className="text-base font-bold text-foreground-700 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Stats */}
      <section className="bg-background-100 py-10 md:py-14">
        <div className="max-w-[1000px] mx-auto px-3 md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="p-4">
              <div className="text-2xl md:text-3xl font-black text-primary-500">10만+</div>
              <div className="text-sm text-foreground-600 mt-1">누적 회원 수</div>
            </div>
            <div className="p-4">
              <div className="text-2xl md:text-3xl font-black text-accent-500">127건</div>
              <div className="text-sm text-foreground-600 mt-1">먹튀 검증 완료</div>
            </div>
            <div className="p-4">
              <div className="text-2xl md:text-3xl font-black text-secondary-500">8개</div>
              <div className="text-sm text-foreground-600 mt-1">보증업체</div>
            </div>
            <div className="p-4">
              <div className="text-2xl md:text-3xl font-black text-primary-400">99.7%</div>
              <div className="text-sm text-foreground-600 mt-1">회원 만족도</div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="max-w-[860px] mx-auto px-3 md:px-4 py-10 md:py-14">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-700">연혁</h2>
          <p className="text-sm text-foreground-600 mt-2">월드컵티비의 성장 이야기</p>
        </div>
        <div className="space-y-0">
          {milestones.map((item, i) => (
            <div key={i} className="flex items-start gap-4">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-3 h-3 rounded-full bg-primary-500" />
                {i < milestones.length - 1 && (
                  <div className="w-0.5 h-16 bg-background-300" />
                )}
              </div>
              <div className="pb-8">
                <span className="inline-block px-2 py-0.5 text-[10px] font-bold bg-primary-500/10 text-primary-500 rounded mb-1">
                  {item.year}
                </span>
                <h3 className="text-base font-bold text-foreground-700">{item.title}</h3>
                <p className="text-sm text-foreground-600 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-[860px] mx-auto px-3 md:px-4 py-12 md:py-16 text-center">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-700 mb-3">
          지금 바로 시작하세요
        </h2>
        <p className="text-sm text-foreground-600 mb-6 max-w-[500px] mx-auto">
          안전하고 신뢰할 수 있는 스포츠 커뮤니티, 월드컵티비 시즌2에서
          다양한 정보와 혜택을 누려보세요
        </p>
        <Link
          to="/register"
          className="inline-flex px-6 py-2.5 bg-primary-500 text-foreground-50 text-sm font-bold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          무료 회원가입
        </Link>
      </section>

      <Footer />
    </div>
  );
}